import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
  IconButton,
  Grid,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button';

interface ImpactShareDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (content: string, metadata: Record<string, unknown>) => void;
}

export const ImpactShareDialog = ({ open, onClose, onSubmit }: ImpactShareDialogProps) => {
  const [metric, setMetric] = useState('');
  const [value, setValue] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = () => {
    if (!metric.trim() || !value.trim()) return;

    onSubmit(`${metric}: ${value}`, {
      type: 'impact_share',
      metric: metric.trim(),
      value: value.trim(),
      description: description.trim() || null,
    });
    handleClose();
  };

  const handleClose = () => {
    setMetric('');
    setValue('');
    setDescription('');
    onClose();
  };

  if (!open) return null;

  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{ style: { borderRadius: 16, overflow: 'hidden' } }}
    >
      <DialogTitle style={{ paddingBottom: 0 }}>
        <Grid container justify='space-between' alignItems='flex-start'>
          <Grid item>
            <Typography style={{ fontWeight: 700, fontSize: '1.15rem', color: '#333' }}>Share Impact</Typography>
            <Typography variant='body2' style={{ color: '#999', marginTop: 2 }}>
              Share an impact metric with the group
            </Typography>
          </Grid>
          <Grid item>
            <IconButton aria-label='Close' size='small' onClick={handleClose} style={{ marginTop: -4 }}>
              <CloseIcon style={{ fontSize: 20, color: '#999' }} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 16, paddingBottom: 8 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label='Metric'
              variant='outlined'
              value={metric}
              onChange={(e) => setMetric(e.target.value)}
              placeholder='e.g. Food sorted, Hours volunteered'
              required
              InputProps={{ style: { borderRadius: 10 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label='Value'
              variant='outlined'
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder='e.g. 200kg, 45 hours'
              required
              InputProps={{ style: { borderRadius: 10 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label='Description (optional)'
              variant='outlined'
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              multiline
              maxRows={3}
              InputProps={{ style: { borderRadius: 10 } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: '8px 20px 16px' }}>
        <TabletButton variant='text' onClick={handleClose} style={{ marginRight: 8, color: '#999' }}>
          Cancel
        </TabletButton>
        <TabletButton
          variant='contained'
          color='primary'
          onClick={handleSubmit}
          disabled={!metric.trim() || !value.trim()}
        >
          Share Impact
        </TabletButton>
      </DialogActions>
    </Dialog>
  );
};
